import { Label } from "@/components/ui/label";
import { JSX } from "react";

import { useTranslation } from "react-i18next";

/**
 * Renders the placeholder for the day input.
 *
 * @returns The JSX element representing the day input placeholder.
 */
export const DayInputPlaceHolder = (): JSX.Element => {
  const { t } = useTranslation(["common"]);

  return (
    <div className="flex items-center -mb-[14px] -mt-4">
      <Label className="w-2/6" />
      <div className="grid-2 w-4/6 text-center text-sm font-semibold">
        {[t("day"), t("night")].map((shift) => (
          <p key={shift}>
            {shift}
          </p>
        ))}
      </div>
    </div>
  );
};
